module.exports = __webpack_public_path__ + "img/tongzhi2.2703c15.svg";